import React, { createContext, useContext, useState, useEffect } from 'react';

const DemoModeContext = createContext();

export const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (!context) {
    throw new Error('useDemoMode must be used within DemoModeProvider');
  }
  return context;
};

export const DemoModeProvider = ({ children }) => {
  // START IN DEMO MODE BY DEFAULT
  const [isDemoMode, setIsDemoMode] = useState(true);
  const [demoPortfolio, setDemoPortfolio] = useState({
    balance: 100000, // $100k demo balance
    positions: [],
    trades: [],
    pnl: 0,
    totalValue: 100000
  });

  // PERSIST DEMO MODE PREFERENCE
  useEffect(() => {
    const savedMode = localStorage.getItem('atticus_demo_mode');
    if (savedMode !== null) {
      setIsDemoMode(JSON.parse(savedMode));
    }
  }, []);

  // PERSIST DEMO PORTFOLIO
  useEffect(() => {
    const savedPortfolio = localStorage.getItem('atticus_demo_portfolio');
    if (savedPortfolio) {
      setDemoPortfolio(JSON.parse(savedPortfolio));
    }
  }, []);

  const toggleDemoMode = () => {
    const newMode = !isDemoMode;
    setIsDemoMode(newMode);
    localStorage.setItem('atticus_demo_mode', JSON.stringify(newMode));
  };

  const updateDemoPortfolio = (updates) => {
    console.log('PORTFOLIO UPDATE DEBUG:', {
      'Current portfolio': demoPortfolio,
      'Updates received': updates,
      'Positions in updates': updates.positions
    });
    
    const newPortfolio = { ...demoPortfolio, ...updates };
    
    console.log('PORTFOLIO UPDATE DEBUG AFTER:', {
      'New portfolio': newPortfolio,
      'New positions array': newPortfolio.positions
    });
    setDemoPortfolio(newPortfolio);
    localStorage.setItem('atticus_demo_portfolio', JSON.stringify(newPortfolio));
  };

  const addDemoTrade = (trade) => {
    const newTrade = {
      ...trade,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      type: 'demo'
    };
    
    const updatedTrades = [...demoPortfolio.trades, newTrade];
    updateDemoPortfolio({ trades: updatedTrades });
  };

  const value = {
    isDemoMode,
    toggleDemoMode,
    demoPortfolio,
    updateDemoPortfolio,
    addDemoTrade
  };

  return (
    <DemoModeContext.Provider value={value}>
      {children}
    </DemoModeContext.Provider>
  );
};
